// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__(38740);
__webpack_require__(23199);
var __webpack_exports__ = __webpack_require__(49820);
